import { Assets } from 'pixi.js'
import { Spine } from '@esotericsoftware/spine-pixi-v8'
import { logger } from '../../framework/core/Logger'

// 贏分慶祝 Spine — 沿用 Unity Animation/ani_win（ani_win_spine）。
const BASE = `${import.meta.env.BASE_URL}spine/win/`

export async function loadWinSpine(): Promise<void> {
  Assets.add({ alias: 'winSkel', src: `${BASE}ani_win.skel` })
  Assets.add({ alias: 'winAtlas', src: `${BASE}ani_win.atlas` })
  await Assets.load(['winSkel', 'winAtlas'])
}

/** 建立贏分慶祝 Spine（播放第一個動畫，不迴圈）。失敗回 null。 */
export function createWinSpine(): Spine | null {
  try {
    const spine = Spine.from({ skeleton: 'winSkel', atlas: 'winAtlas' })
    const animations = spine.skeleton.data.animations
    if (animations.length > 0) {
      spine.state.setAnimation(0, animations[0].name, true)
    }
    return spine
  } catch (error) {
    logger.error('贏分 Spine 建立失敗', error)
    return null
  }
}
